export const errors = {
  CHAT_DISABLED: 'Not found. Contact customer support to get started',
  SEARCH_EMPTY:
    "We couldn't find anything matching your search.\n Try using a different term",
}
